import { render, staticRenderFns } from "./Berechnungsvorlagen.vue?vue&type=template&id=c016e7ac"
import script from "./Berechnungsvorlagen.vue?vue&type=script&lang=js"
export * from "./Berechnungsvorlagen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports